import React from 'react';
import { Link } from 'react-router-dom';
import {Col, Container, Row } from 'reactstrap';
import { Helmet } from "react-helmet";

// Import Images
import error404 from "../../assets/images/error-img.png";
const Error404 = () => {

    return (
        <React.Fragment>
            <Helmet>
                <title>找不到頁面｜DC Keeper</title>
            </Helmet>
            <div className="bg-light">
                <div className="authentication-bg min-vh-100 py-5 py-lg-0">
                    <div className="bg-overlay bg-light"></div>
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Row>
                                    <div className="col-lg-12">
                                        <div className="text-center mb-5">
                                            <h1 className="error-title"> <span className="blink-infinite">404</span></h1>
                                            <h4>找不到這個頁面</h4>
                                            <p className="font-size-15 mx-auto text-muted w-50 mt-4">您要的頁面不存在，或不在目前開放的範圍內。</p>
                                            <div className="mt-5 text-center">
                                                <Link className="btn btn-primary waves-effect waves-light" to="/dashboard">回智慧看板</Link>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                                <Row className="justify-content-center">
                                    <div className="col-md-8 col-xl-7">
                                        <div className="mt-2">
                                            <img src={error404} alt="" className="img-fluid" />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment >
    );
};

export default Error404;